import { GracenoteTeam } from "types";
import { useGracenoteTeams } from "./gracenote";

export const useTeams = (sportsData: any) => {

    const { data, isLoading } = useGracenoteTeams();

    const transformedArray = sportsData.map((item) => ({
        sportsId: item.sport.id.toString(),
        sportsName: item.sport.label || item.sport.sportsName,
    }));

    if (isLoading) {
        return undefined;
    }

    return transformedArray.reduce(
        (acc, iter) => {
            return {
                ...acc,
                [iter.sportsId]:
                    data?.filter((team) => `${team.sport.id}` == iter.sportsId) || [],
            };
        },
        {} as Record<string, GracenoteTeam[]>
    );
};